<form class="needs-validation" [formGroup]="coveredCitiesFormGroup">
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label for="" class="form-label"> المنطقة الأساسية <span class="red">*</span> </label>
        <ng-select bindLabel="name" class="single-select" class="single-select" #selectPrimaryRegion
          (change)="onPrimaryRegionSelected($event)"
          placeholder="يرجى تحديد المنطقة الأساسية" appendTo="body" formControlName="primary_region" 
          [searchable]="true" [clearable]="true" [items]="regions" bindLabel="name" bindValue="pk">
        </ng-select>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group">
        <label for="" class="form-label"> المدينة الأساسية <span class="red">*</span> </label>
        <ng-select bindLabel="name" class="single-select" class="single-select" #selectPrimaryCity
          (change)="onPrimaryCitySelected($event)"
          placeholder="يرجى تحديد المدينة الأساسية" appendTo="body" formControlName="primary_city" 
          [searchable]="true" [clearable]="true" [items]="primaryCities" bindLabel="name" bindValue="pk">
        </ng-select>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group">
        <label for="" class="form-label"> المناطق الإضافية </label>
        <app-select
          [optionItems]="regions"
          placeholder="يرجى تحديد المناطق الإضافية"
          [id]="'additional_regions'"
          [initValues]="savedAdditionalRegions"
          [maxLength]="2"
          [bindValue]="'pk'"
          (selectedOptions)="onAdditionalRegionChanged($event)"
        >
        </app-select>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group">
        <label for="" class="form-label"> المدينة الإضافية </label>
        <app-select
          [optionItems]="additionalCities"
          placeholder="يرجى تحديد المدن الإضافية"
          [id]="'additional_cities'"
          [initValues]="savedAdditionalCities"
          [maxLength]="2"
          [bindValue]="'pk'"
          (selectedOptions)="onAdditionalCityChanged($event)"
          [class.ng-invalid]="showError"
        >
        </app-select>
        @if(showError) {
          <span class="text-danger"> لا يمكن اختيار المدينة الأساسية كمدينة إضافية </span>
        }
      </div>
    </div>

  </div>
</form>
